import { Helpers } from '@grandvisionhq/products';
import { createAlgoliaFilters, AlgoliaFilterOperator } from './create-algolia-filters.js';
import { getLocalizedAttributes } from './get-localized-attributes.js';
import { getProductAttributesByFacets } from './get-product-attributes-from-facets.js';

/**
 * getAlgoliaFilters
 * Returns a subset of the algolia search paramaters.
 * This function returns the `filters` and the `optionalFilters`
 */ const getAlgoliaFilters = (product, facets, activeSku, locale)=>{
    /**
   * Get all the sku's from the product
   * Create a filter string that excludes these skus from the result e.g:
   * `NOT masterVariant.sku:sku1 AND NOT masterVariant.sku:sku2`
   */ const masterVariantSku = {
        id: 'masterVariant.sku',
        value: product.masterVariant.sku
    };
    const variantSkus = product.variants.map((variant)=>({
            id: 'masterVariant.sku',
            value: variant.sku
        })
    );
    const excludedSkus = createAlgoliaFilters([
        masterVariantSku,
        ...variantSkus
    ], AlgoliaFilterOperator.AND_NOT, AlgoliaFilterOperator.NOT);
    /**
   * Retrieve all the attributes from the product
   * The product attributes are checked against the facets,
   * if they exist in the facets, they will be returned.
   */ const variant1 = Helpers.getActiveVariant(product, activeSku);
    const attributes = getProductAttributesByFacets(facets, getLocalizedAttributes(variant1.attributes, locale), locale);
    /**
   *  Create strict filters, if there are no strict filters, use only the skus
   */ const strictAttributes = attributes.filter((attribute)=>attribute.type === 'strict'
    );
    const filters = strictAttributes.length > 0 ? `${createAlgoliaFilters(strictAttributes, AlgoliaFilterOperator.AND)} ${AlgoliaFilterOperator.AND} ${excludedSkus}` : excludedSkus;
    /**
   *  Create optional filters
   */ const optionalAttributes = attributes.filter((attribute)=>attribute.type === 'optional'
    );
    const optionalFilters = createAlgoliaFilters(optionalAttributes);
    return {
        filters,
        optionalFilters
    };
};

export { getAlgoliaFilters };
//# sourceMappingURL=get-algolia-filters.js.map
